import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../Components/Footer";

export default function TermsAndConditions() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(
    localStorage.getItem("lang") ? (localStorage.getItem("lang") === "en" ? "ar" : "en") : "ar"
  );

  useEffect(() => {
    const saved = localStorage.getItem("lang") || "en";
    i18n.changeLanguage(saved);
    const newDir = saved === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = newDir;
    document.documentElement.lang = saved;
    setLanguage(saved === "en" ? "ar" : "en");
  }, [i18n]);

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    localStorage.setItem("lang", newLang);
    i18n.changeLanguage(newLang);
    const newDir = newLang === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = newDir;
    document.documentElement.lang = newLang;
    setLanguage(newLang === "en" ? "ar" : "en");
  };

  const isAr = i18n.language === "ar";

  const legalSections = isAr
    ? [
        {
          num: "1",
          title: "قبول الشروط",
          body: 'من خلال الوصول إلى موقع Smart Container أو تطبيق الهاتف المحمول ("الخدمة") أو استخدامهما، فإنك توافق على الالتزام بهذه الشروط والأحكام ("الشروط"). إذا لم توافق، فلا تستخدم الخدمة. يتم تقديم الخدمة من قبل Orb.'
        },
        {
          num: "2",
          title: "وصف الخدمة",
          body: "تساعد Smart Container الأفراد في تحديد موقع صناديق إعادة التدوير الذكية القريبة، وتقديم المواد البلاستيكية القابلة لإعادة التدوير، وكسب مكافآت مالية تُحول إلى حساباتهم البنكية. يمكن للشركاء تسجيل المواقع لاستضافة الحاويات."
        },
        {
          num: "3",
          title: "حسابات المستخدمين والأهلية",
          body: "",
          list: [
            "يجب أن يكون عمرك 18 عامًا على الأقل أو تحصل على موافقة الوالدين.",
            "أنت مسؤول عن الحفاظ على سرية بيانات اعتماد حسابك.",
            "حساب واحد لكل شخص. قد يؤدي وجود حسابات متعددة إلى إنهاء الخدمة ومصادرة المكافآت."
          ]
        },
        {
          num: "4",
          title: "برنامج مكافآت إعادة التدوير",
          body: "يتم حساب المكافآت بناءً على وزن البلاستيك المُتحقق منه والأسعار الحالية. نحتفظ بالحق في تعديل الأسعار وحدود الحد الأدنى للدفع ومتطلبات التحقق في أي وقت. تخضع المكافآت للتحقق الناجح وقد تتأخر أو تُرفض في حال الاشتباه في الاحتيال أو التلوث."
        },
        {
          num: "5",
          title: "الاستخدام المقبول",
          body: "توافق على عدم:",
          list: [
            "تقديم مواد غير قابلة لإعادة التدوير أو خطرة",
            "العبث بالحاويات الذكية أو إتلافها أو نقلها",
            "استخدام روبوتات أو نصوص برمجية أو وسائل آلية لتقديم المواد أو إنشاء حسابات",
            "تقديم معلومات كاذبة أو انتحال شخصية الآخرين",
            "التدخل في التشغيل السليم للخدمة"
          ]
        },
        {
          num: "6",
          title: "شروط الشركاء",
          body: "يوافق الشركاء الذين يستضيفون الحاويات على توفير مواقع آمنة وسهلة الوصول، والحفاظ على المنطقة المحيطة بالحاوية، والسماح بالوصول المعقول للجمع والصيانة. يحصل الشركاء على ظهور ويمكنهم كسب فوائد إحالة أو استضافة كما هو موضح في اتفاقيات منفصلة."
        },
        {
          num: "7",
          title: "الملكية الفكرية",
          body: "جميع المحتويات والشعارات والبرمجيات والعلامات التجارية على الخدمة مملوكة لـ Orb أو مرخصيها. لا يجوز لك نسخ أو تعديل أو توزيع أي جزء من الخدمة دون إذن كتابي مسبق."
        },
        {
          num: "8",
          title: "تحديد المسؤولية",
          body: "إلى أقصى حد يسمح به القانون، لن تكون Orb مسؤولة عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية تنشأ عن استخدامك للخدمة، بما في ذلك على سبيل المثال لا الحصر فقدان المكافآت أو البيانات أو الأرباح."
        },
        {
          num: "9",
          title: "إنهاء الخدمة",
          body: "يجوز لنا تعليق أو إنهاء وصولك إلى الخدمة في أي وقت بسبب انتهاك هذه الشروط أو لأي سبب آخر، مع أو بدون إشعار. عند الإنهاء، قد تُصادر أي مكافآت معلقة."
        },
        {
          num: "10",
          title: "القانون الحاكم والنزاعات",
          body: "تخضع هذه الشروط لقوانين المملكة العربية السعودية. تُحل أي نزاعات في محاكم الرياض. توافق على محاولة حل النزاع بحسن نية قبل تقديم أي مطالبة."
        },
        {
          num: "11",
          title: "التغييرات على الشروط",
          body: 'يجوز لنا مراجعة هذه الشروط في أي وقت. سيتم نشر النسخة المحدثة مع تاريخ "آخر تحديث" جديد. استمرار استخدامك بعد التغييرات يعني قبولك للشروط الجديدة.'
        },
        {
          num: "12",
          title: "الاتصال",
          bodyPrefix: 'للاستفسارات حول هذه الشروط، يرجى استخدام نموذج "اتصل بنا" أو إرسال بريد إلكتروني إلى '
        }
      ]
    : [
        {
          num: "1",
          title: "Acceptance of Terms",
          body: 'By accessing or using the Smart Container website or mobile application (the "Service"), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree, do not use the Service. The Service is provided by Orb.'
        },
        {
          num: "2",
          title: "Description of Service",
          body: "Smart Container helps individuals locate nearby smart recycling bins, submit recyclable plastic materials, and earn financial rewards transferred to their bank accounts. Partners can register locations to host containers."
        },
        {
          num: "3",
          title: "User Accounts & Eligibility",
          body: "",
          list: [
            "You must be at least 18 years old or have parental consent.",
            "You are responsible for maintaining the confidentiality of your account credentials.",
            "One account per person. Multiple accounts may result in termination and forfeiture of rewards."
          ]
        },
        {
          num: "4",
          title: "Recycling Rewards Program",
          body: "Rewards are calculated based on verified plastic weight and current rates. We reserve the right to adjust rates, minimum payout thresholds, and verification requirements at any time. Rewards are subject to successful verification and may be delayed or denied for suspected fraud or contamination."
        },
        {
          num: "5",
          title: "Acceptable Use",
          body: "You agree not to:",
          list: [
            "Submit non-recyclable or hazardous materials",
            "Tamper with, damage, or move Smart Containers",
            "Use bots, scripts, or automated means to submit materials or create accounts",
            "Provide false information or impersonate others",
            "Interfere with the proper functioning of the Service"
          ]
        },
        {
          num: "6",
          title: "Partner Terms",
          body: "Partners who host containers agree to provide safe, accessible locations, maintain the area around the container, and allow reasonable access for collection and maintenance. Partners receive visibility and may earn referral or hosting benefits as outlined in separate agreements."
        },
        {
          num: "7",
          title: "Intellectual Property",
          body: "All content, logos, software, and trademarks on the Service are owned by Orb or its licensors. You may not copy, modify, or distribute any part of the Service without prior written permission."
        },
        {
          num: "8",
          title: "Limitation of Liability",
          body: "To the maximum extent permitted by law, Orb shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service, including but not limited to loss of rewards, data, or profits."
        },
        {
          num: "9",
          title: "Termination",
          body: "We may suspend or terminate your access to the Service at any time for violation of these Terms or for any other reason, with or without notice. Upon termination, any pending rewards may be forfeited."
        },
        {
          num: "10",
          title: "Governing Law & Disputes",
          body: "These Terms are governed by the laws of the Kingdom of Saudi Arabia. Any disputes shall be resolved in the courts of Riyadh. You agree to attempt good-faith resolution before filing any claim."
        },
        {
          num: "11",
          title: "Changes to Terms",
          body: 'We may revise these Terms at any time. The updated version will be posted with a new "Last Updated" date. Your continued use after changes means you accept the new Terms.'
        },
        {
          num: "12",
          title: "Contact",
          bodyPrefix: "For questions about these Terms, please use the Contact Us form or email "
        }
      ];

  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900">
      {/* Legal Page Header */}
      <header className="sticky top-0 z-50 bg-white border-b shadow-sm">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src="/images/orb-logo.png" alt="Smart Container Logo" className="h-10 md:h-12" />
            <span className="font-semibold text-lg hidden sm:block text-[#209163]">Smart Container</span>
          </Link>

          <div className="flex items-center gap-3 md:gap-4">
            <Link
              to="/"
              className="hidden md:inline text-sm font-medium text-gray-700 hover:text-[#209163] transition-colors"
            >
              {t("back-to-home")}
            </Link>

            {/* Language Switcher */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium border rounded-md hover:bg-gray-50 transition"
              aria-label="Toggle language"
            >
              <img src="/images/lang-icon.png" alt="Language" className="w-4 h-4" />
              <span className="uppercase">{language}</span>
            </button>

            <Link
              to="/"
              className="md:hidden text-xs px-3 py-1.5 rounded bg-[#209163] text-white font-medium hover:bg-[#187a52]"
            >
              {t("back-to-home").replace("← ", "")}
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 container mx-auto px-4 py-8 md:py-12 max-w-4xl">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[#209163] mb-2">
            {t("terms-title")}
          </h1>
          <p className="text-sm text-gray-500">{t("last-updated")}</p>
        </div>

        <div className="prose prose-gray max-w-none text-[15px] leading-relaxed space-y-8">
          {legalSections.map((section, index) => (
            <section key={index}>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">
                {section.num}. {section.title}
              </h2>
              {section.body && <p>{section.body}</p>}
              {section.bodyPrefix && (
                <p>
                  {section.bodyPrefix}
                  <a href="mailto:legal@orb.sa" className="text-[#209163] underline">legal@orb.sa</a>.
                </p>
              )}
              {section.list && (
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  {section.list.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
